import { VDataTable } from 'vuetify/lib/components/VDataTable';

var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(VDataTable, {
        staticClass: "table-inca",
        attrs: {
          headers: _vm.headers,
          items: _vm.item.users,
          dense: "",
          "hide-default-footer":
            Object.keys(_vm.item.users).length <= 10 ? true : false,
        },
        scopedSlots: _vm._u([
          {
            key: "item.index",
            fn: function (ref) {
              var index = ref.index
              return [_vm._v(_vm._s(index + 1))]
            },
          },
        ]),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }